import { createSlice } from '@reduxjs/toolkit';

export const EpsSlice = createSlice({
  name: 'eps',
  initialState: {
    eps_list: [],
    eps_list_select: [],
  },
  reducers: {
    setEpsRedux: (state, { payload }) => {
      state.eps_list = payload;
    },
    setEpsSelectRedux: (state, { payload }) => {
      state.eps_list_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setEpsRedux, setEpsSelectRedux } = EpsSlice.actions;
